module.exports = __webpack_public_path__ + "static/media/SWSCRC6-21.2b449249.mp3";